<template>
  <div :style="{ overflow: 'hidden', padding: '1rem'}" class="manualPage flex">
    <div class="leftPanel" style="width: 240px; min-width: 240px; max-width: 240px!important">
      <Tree
        :data="catalogTree"
        :render="renderContent"
        @on-select-change="changeCata"
        class="selfTree"
      ></Tree>
    </div>
    <div class="rightPanel">
      <filePreview :fileOption="fileInfo" style="width: 100%" v-if="fileInfo"></filePreview>
    </div>
  </div>
</template>
<script>
export default {
  name: 'manual',
  data () {
    return {
      fileInfo: null,
      currentNodeId: null,
      catalogTree: [],
    }
  },
  methods: {
    renderContent (h, { root, node, data }) {
      let _this = this
      if (data.fileInfo == null || data.fileInfo == undefined) {
        return h('span', {
          style: {
            display: 'inline-block',
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between'
          }
        }, [
          h('span', {
            style: {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              color: '#888',
              cursor: 'not-allowed'
            }
          }, [
            h('Icon', {
              props: {
                type: 'ios-folder-outline'
              },
              style: {
                marginRight: '4px',
                // overflow: 'hidden',
                // textOverflow: 'ellipsis'
              }
            }),
            h('span', data.title)
          ])])
      } else {
        return h('span', {
          style: {
            display: 'inline-block',
            width: '100%',
            display: 'flex',
            padding: '0 2px',
            justifyContent: 'space-between',
            borderRadius: '3px',
            background: _this.currentNodeId == data.id ? '#5cadff' : '',
            color: _this.currentNodeId == data.id ? '#fff' : '#666'
          },
          on: {
            'click': function () {
              console.log('ccc', data)
              _this.currentNodeId = data.id
              _this.fileInfo = Object.assign({}, data.fileInfo)
              _this.fileInfo.fileId = _this.fileInfo.id
              _this.fileInfo.filePath = _this.fileInfo.url
            }
          }
        }, [
          h('span', {
            style: {
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }
          }, [
            h('Icon', {
              props: {
                type: 'md-bookmarks'
              },
              style: {
                marginRight: '4px',
                // overflow: 'hidden',
                // textOverflow: 'ellipsis'
              }
            }),
            h('span', data.title)
          ])
        ])
      }
    },
    changeCata: function (checked, current) {
      console.log(checked, current)
      if (checked.length == 0) {
        this.roleCode = '*'
        this.catalogTree[0].selected = false
      } else {
        this.roleCode = current.value
      }
    },
    getRoleOptions: function () {
      let that = this
      this.$axios.post(this.$apis.manualApi.getUserFiles).then(res => {
        if (res.success) {
          that.catalogTree = [{
            title: '用户操作手册',
            value: '*',
            disabled: true,
            id: null,
            expand: true,
            children: res.result || []
          }]
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error('获取权限列表失败！')
      })
    },
    getFile: function () {
      let that = this
      this.$axios.post(that.$apis.manualApi.getFile).then(res => {
        if (res.success) {
          that.fileInfo = res.result || {}
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error("获取文件失败！")
      })
    },
  },
  beforeMount () {
    this.getRoleOptions()
  }
}
</script>
<style lang="less" scoped>
.manualPage {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>